import { ref } from 'vue'
import { defineStore } from 'pinia'
import type { UserWalletDto } from '@roadfootage/api-client'

import { useApi } from '../../composables/api'

export const useWalletStore = defineStore('wallet', () => {
  const { meApi } = useApi()
  const pointsBalance = ref<number | null>(null)

  function setWallet(dto: UserWalletDto | null | undefined) {
    pointsBalance.value = dto?.pointsBalance ?? null
  }

  async function fetchWallet() {
    const dto = await meApi.meGetUserWallet()
    setWallet(dto)
  }

  return { pointsBalance, setWallet, fetchWallet }
})
